import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import useSWR from "swr";
import { DateTime, Interval } from "luxon";
import { getStatsControllerGetMetricRangesV0Url, statsControllerGetMetricRangesV0, getStatsControllerGetVehicleTypesV0Url, statsControllerGetVehicleTypesV0, getStatsControllerGetTimeIntervalsV0Url, statsControllerGetTimeIntervalsV0 } from "../generated/endpoints/stats/stats";
import type { StatsControllerGetMetricRangesV0200, VehicleTypesDto } from "../generated/models";
import { ApiResponse } from "@/types/apiResponse";
export const useMetricRanges = () => {
  return useSWR(getStatsControllerGetMetricRangesV0Url, statsControllerGetMetricRangesV0);
};
export const useVehicleTypes = () => {
  return useSWR(getStatsControllerGetVehicleTypesV0Url, statsControllerGetVehicleTypesV0);
};
export interface ParsedTimeIntervalsDto {
  timeIntervals: Interval[];
}
export const useTimeIntervals = () => {
  const $ = _c(6);
  const {
    data,
    error,
    isLoading
  } = useSWR(getStatsControllerGetTimeIntervalsV0Url, statsControllerGetTimeIntervalsV0);
  let t0;
  if ($[0] !== data) {
    t0 = data ? {
      timeIntervals: data.timeIntervals.map(_temp)
    } : undefined;
    $[0] = data;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const parsed = t0;
  let t1;
  if ($[2] !== error || $[3] !== isLoading || $[4] !== parsed) {
    t1 = {
      data: parsed,
      error,
      isLoading
    };
    $[2] = error;
    $[3] = isLoading;
    $[4] = parsed;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
function _temp(iv) {
  return Interval.fromDateTimes(DateTime.fromISO(iv.start), DateTime.fromISO(iv.end));
}